/** Backend: 0 = lundi … 6 = dimanche (aligné sur Python weekday). */

export function dateToBackendWeekday(d: Date): number {
  const js = d.getDay();
  return js === 0 ? 6 : js - 1;
}

export function buildMonthGrid(year: number, month: number): (Date | null)[] {
  const first = new Date(year, month, 1);
  const pad = (first.getDay() + 6) % 7;
  const dim = new Date(year, month + 1, 0).getDate();
  const cells: (Date | null)[] = Array(pad).fill(null);
  for (let day = 1; day <= dim; day++) {
    cells.push(new Date(year, month, day));
  }
  const tail = (7 - (cells.length % 7)) % 7;
  for (let i = 0; i < tail; i++) cells.push(null);
  return cells;
}

export const WEEKDAY_HEADERS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"] as const;

export const WEEKDAY_LABELS_FR = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"] as const;

/** « tous les … » (pluriel usuel) */
export const WEEKDAY_PLURAL_FR = [
  "lundis",
  "mardis",
  "mercredis",
  "jeudis",
  "vendredis",
  "samedis",
  "dimanches",
] as const;

const MOIS_FR = [
  "janvier",
  "février",
  "mars",
  "avril",
  "mai",
  "juin",
  "juillet",
  "août",
  "septembre",
  "octobre",
  "novembre",
  "décembre",
] as const;

export function formatMonthTitleFr(year: number, month: number): string {
  return `${MOIS_FR[month]} ${year}`;
}

export function formatDayTitleFr(d: Date): string {
  const wd = WEEKDAY_LABELS_FR[dateToBackendWeekday(d)];
  return `${wd} ${d.getDate()} ${MOIS_FR[d.getMonth()]} ${d.getFullYear()}`;
}

/** YYYY-MM-DD (local) */
export function formatYmdLocal(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
